<button type="button" [disabled]="disabled" id="{{aid}}">
  @if (label) {
    <span>{{label}}</span>
  }
  @if (label && icon) {
    <span class="label">&nbsp;</span>
  }
  @if (icon) {
    <i class="{{icon}}"></i>
  }
</button>